import styled, { css } from 'styled-components'

import { BRAND } from 'constants/appConstants'
import { theme } from 'utils/theme'

export const SearchBar = styled.div`
  width: 100%;
  height: 124px;
`

export const SearchBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 26px 40px;
`

export const NavigateBack = styled.div`
  ${({ theme: { brand } }) =>
    brand === BRAND.ATH
      ? css`
          font-family: AzoSans;
          font-weight: 600;
          font-size: 26px;
          line-height: 28px;
        `
      : css`
          font-family: 'Futura Std';
          font-weight: 650;
          font-size: 22px;
          line-height: 26px;
        `}

  ${({ theme: { brand }, pill }) =>
    brand === BRAND.GCAD &&
    pill &&
    css`
      background: ${theme.colors.gcadOrange};
      padding: 12px 24px;
      border-radius: 100px;
    `}
`
